<style lang="less" scoped>
.video-list {
  display: flex;
  flex-wrap: wrap;
  align-items: flex-start;
  //justify-content: center;

  .video-item {
    width: 140px;
    margin: 5px;
    cursor: pointer;

    img {
      border: solid 2px #ccc;
      border-radius: @border-radius-base;
      width: 140px;
      height: 80px;
    }

    .active {
      border: solid 3px skyblue;
    }

    .title {
      width: 100%;
      padding: 2px 5px;
      font-size: 14px;
      line-height: 1.8em;
      white-space: nowrap;
      text-overflow: ellipsis;
      overflow: hidden;
    }
  }
}

.link-box {
  position: relative;
  margin: auto;
  width: 600px;
  height: 300px;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  border: solid 1px #ccc;
  background-color: #666;
  padding: 20px;

  .tip {
    position: absolute;
    top: 10px;
    left: 10px;
    color: #ccc;
    font-size: 14px;
  }

  a {
    color: burlywood;
  }
}

/deep/ .vjs-custom-skin > .video-js .vjs-big-play-button {
  display: none !important;
}
</style>

<template>
  <div style="text-align: center">
    <div v-if="videos[curIndex].type === 5" class="link-box">
      <p class="tip">由于版权问题，请点击下面文字链接去观看。</p>
      <p>
        <a :href="videos[curIndex].path" target="_blank">{{
            videos[curIndex].name
          }}</a>
      </p>
    </div>
    <div v-else @contextmenu.prevent="none">
      <!--      <video-player class="video-player vjs-custom-skin" ref="myVideo" :playsinline="true"-->
      <!--                    :options="playerOptions">-->
      <!--      </video-player>-->
    </div>
    <div class="video-list" v-if="videos && videos.length > 1">
      <div v-for="(video, i) in videos" class="video-item" :key="video.id" :title="video.name" @click="
          curIndex = i;
          getStream(video.path || video.videoPath || video.filePath, videos[i].type, true);
        ">
        <!-- <img
          :src="`${$resBasePath}${video.coverPath || video.videoPhotoCover}`"
          :class="{ active: curIndex === i }"
        /> -->
        <img v-if="video.coverPath!=null||video.videoPhotoCover!=null"
             :src="`${$resBasePath}${video.coverPath || video.videoPhotoCover}`"
             :class="{ active: curIndex === i }"/>
        <img v-if="!video.coverPath&&!video.videoPhotoCover" src="@/assets/imgs/video.png" alt=""
             @click="preVVideo(i)"
             :class="{ active: curIndex === i }"/>
        <p class="title">{{ video.name || "视频 " + (i + 1) }}</p>
      </div>
    </div>

    <a-modal
        title="视频预览"
        width="800px"
        v-model="videoVisible"
        :footer="null"
        centered
        :destroyOnClose="true"
    >
      <ts-video ref="myVideo" :videos="videos" :index="videoIndex"></ts-video>
    </a-modal>
  </div>
</template>

<script>
import {getFileExp} from 'utils/getFileInfo.js'
import {videoPlayer} from 'vue-video-player'
import 'videojs-contrib-hls'
import 'video.js/dist/video-js.css'
import tsVideo from '@/views/books/components/tsVideos.vue'

export default {
  name: 'tsNew',
  components: {
    videoPlayer,
    tsVideo
  },
  props: {
    videos: {
      type: Array,
      default: () => {
        return []
      }
    },
    width: {
      type: String,
      default: '80%'
    },
    height: {
      type: String,
      default: '80%'
    }
  },
  watch: {
    videos() {
      if (this.videos && this.videos.length > 0) {
        this.getStream(this.videos[0].path || this.videos[0].videoPath || this.videos[0].filePath, this.videos[0].type)
      }
    }
  },
  mounted() {
    if (this.videos && this.videos.length > 0) {
      this.getStream(this.videos[0].path || this.videos[0].videoPath || this.videos[0].filePath, this.videos[0].type)
    }
  },
  data() {
    return {
      mrImg: require('../../../assets/imgs/video1.png'),
      hls: null,
      curPoster: '',
      curIndex: 0,
      videoIndex: 0,
      getFileExp,
      videoVisible: false,
      playerOptions: {
        playbackRates: [0.5, 1.0, 1.5, 2.0], // 可选的播放速度
        autoplay: false, // 如果为true,浏览器准备好时开始回放。
        muted: false, // 默认情况下将会消除任何音频。
        loop: false, // 是否视频一结束就重新开始。
        preload: 'auto', // 建议浏览器在<video>加载元素后是否应该开始下载视频数据。auto浏览器选择最佳行为,立即开始加载视频（如果浏览器支持）
        language: 'zh-CN',
        aspectRatio: '16:9', // 将播放器置于流畅模式，并在计算播放器的动态大小时使用该值。值应该代表一个比例 - 用冒号分隔的两个数字（例如"16:9"或"4:3"）
        fluid: true, // 当true时，Video.js player将拥有流体大小。换句话说，它将按比例缩放以适应其容器。
        sources: [
          {
            type: 'video/mp4', // 类型
            src: '' // url地址
          },
          {
            type: 'application/x-mpegURL', // 类型
            src: '' // url地址
          }
        ],
        poster: '',
        // poster: this.$resBasePath+(this.videos[this.curIndex].coverPath || this.videos[this.curIndex].videoPhotoCover), // 封面地址
        notSupportedMessage: '此视频暂无法播放，请稍后再试', // 允许覆盖Video.js无法播放媒体源时显示的默认信息。
        controlBar: {
          timeDivider: true, // 当前时间和持续时间的分隔符
          durationDisplay: true, // 显示持续时间
          remainingTimeDisplay: false, // 是否显示剩余时间功能
          fullscreenToggle: true // 是否显示全屏按钮
        }
      }
    }
  },
  methods: {
    getStream(source, type, autoPlay = false) {
      if (type === 5) return
      this.playerOptions.autoplay = autoPlay
      this.playerOptions.poster =
          (this.videos[this.curIndex].coverPath || this.videos[this.curIndex].videoPhotoCover)
            ? (this.$resBasePath + (this.videos[this.curIndex].coverPath || this.videos[this.curIndex].videoPhotoCover))
            : this.mrImg
      if (source.search('http://') === -1 && source.search('https://') === -1) {
        source = this.$resBaseVideo + '/' + source // url地址
      }
      if (this.getFileExp(source) !== 'm3u8') {
        this.playerOptions.sources[0].src = source // url地址
        return
      }
      this.playerOptions.sources[1].src = source // url地址
    },
    preVVideo(index) {
      this.videoIndex = index
      this.videoVisible = true
    }
  }
}
</script>
